export const DASHBOARD_INK = {
	PRIMARY: "#0b0b0b",
	SECONDARY: "#52514e",
	MUTED: "#898781",
	GRID: "#e1e0d9",
	AXIS: "#c3c2b7",
} as const;
